import styled from '@emotion/styled';
import StarIcon from '@mui/icons-material/Star';

const StyledIconContent = styled(StarIcon)(
  {
    fontSize: 11,
    marginRight: '3px'
  },
  ({ theme }) => ({
    color: theme.palette.colors.gold
  })
);

export default StyledIconContent;
